const isChirpInURL = () => {
  const urlMatch = window.location.href.match(/[?]isChirp=(\w+)/);
  if (!urlMatch) return;
  return urlMatch[1] === 'true';
};
export default isChirpInURL;